import React, { RefObject } from 'react';
import { ColourTheme } from '../../../types/ColourTheme';
import { PersonaHero } from './PersonaHero/PersonaHero';
import './PersonaTemplate.scss';
import { PersonaVideo } from './PersonaVideo/PersonaVideo';
import { PersonaContent } from './PersonaContent/PersonaContent';
import { PersonaReport } from './PersonaReport/PersonaReport';
import { PersonaComparison } from './PersonaComparison/PersonaComparison';
import { PersonaRecommend } from './PersonaRecommend/PersonaRecommend';
import { scrollToRef } from '../../../newHelpers/scrollToRef';
import { Menu } from '../Menu/Menu';
import { PersonaQuote } from './PersonaQuote/PersonaQuote';
import { PersonaGenes } from './PersonaGenes/PersonaGenes';

type Props = {
  theme: ColourTheme;
};

export const PersonaTemplate = (props: Props) => {
  const contentRef: RefObject<HTMLDivElement> = React.createRef();

  return (
    <div className={`PersonaTemplate ${props.theme}`}>
      <Menu />
      <PersonaHero theme={props.theme} toggleScroll={() => scrollToRef(contentRef)} />
      <PersonaVideo theme={props.theme} refProps={contentRef} />
      <PersonaContent theme={props.theme} />
      {(props.theme === ColourTheme.cerulean || props.theme === ColourTheme.skyblue) && <PersonaQuote theme={props.theme} />}
      <PersonaReport theme={props.theme} />
      {(props.theme === ColourTheme.pomegranate || props.theme === ColourTheme.orchidpink) && <PersonaGenes theme={props.theme} />}
      <PersonaComparison theme={props.theme} />
      <PersonaRecommend theme={props.theme} />
    </div>
  );
};
